import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController,ModalController,IonRouterOutlet,ActionSheetController } from '@ionic/angular';
import { Camera, CameraOptions,PictureSourceType } from '@awesome-cordova-plugins/camera/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FilePath } from '@awesome-cordova-plugins/file-path/ngx';
import { TermsPage } from '../terms/terms.page';
import {Constant} from "../shared/model/Constant";

declare var cordova: any;

@Component({
  selector: 'app-logo',
  templateUrl: './logo.page.html',
  styleUrls: ['./logo.page.scss'],
})

export class LogoPage implements OnInit {

  hasTerm = false;
  user_id:any;
  res:any;
  show_form = false;
  lastImage:any;
  showImage:any;
  text:any;

  constructor(public actionSheetController: ActionSheetController,public modalController: ModalController,private camera: Camera,private transfer: FileTransfer,private filePath: FilePath,private file: File,public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController,private platform : Platform){

  this.text = JSON.parse(localStorage.getItem(Constant.appText));

  }

  ngOnInit()
  {

  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }

  async showOption()
  {
    const actionSheet = await this.actionSheetController.create({
      header: this.text.select_option,
      cssClass: 'my-custom-class',
      buttons: [{
        text: this.text.camera,
        icon: 'camera',

        handler: () => {

        this.selectImage(this.camera.PictureSourceType.CAMERA);

        }
      }, {
        text: this.text.photo_lib,
        icon: 'image',
        handler: () => {
          this.selectImage(this.camera.PictureSourceType.PHOTOLIBRARY);
        }
      }]
    });
    await actionSheet.present();

    const { role, data } = await actionSheet.onDidDismiss();
    console.log('onDidDismiss resolved with role and data', role, data);
  }

  selectImage(src)
  {
    this.takePicture(src);
  }

  takePicture(sourceType: PictureSourceType) {

    console.log("Dd");

    var options: CameraOptions = {
        quality: 100,
        sourceType: sourceType,
        saveToPhotoAlbum: false,
        correctOrientation: true,
        allowEdit: false,
    };

    this.camera.getPicture(options).then(imagePath => {
        if (this.platform.is('android') && sourceType === this.camera.PictureSourceType.PHOTOLIBRARY) {
            this.filePath.resolveNativePath(imagePath)
                .then(filePath => {
                    let correctPath = filePath.substr(0, filePath.lastIndexOf('/') + 1);
                    let currentName = imagePath.substring(imagePath.lastIndexOf('/') + 1, imagePath.lastIndexOf('?'));
                    this.copyFileToLocalDir(correctPath, currentName, this.createFileName());
                });
        } else {
            var currentName = imagePath.substr(imagePath.lastIndexOf('/') + 1);
            var correctPath = imagePath.substr(0, imagePath.lastIndexOf('/') + 1);
            this.copyFileToLocalDir(correctPath, currentName, this.createFileName());
        }
    });

}

createFileName() {
    var d = new Date(),
        n = d.getTime(),
        newFileName = n + ".jpg";
    return newFileName;
}

copyFileToLocalDir(namePath, currentName, newFileName) {
    this.file.copyFile(namePath, currentName, cordova.file.dataDirectory, newFileName).then(success => {

    this.lastImage = newFileName;

    }, error => {
        this.presentToast('Error while storing file.');
    });
}

pathForImage(img) {
    if (img === null) {
      return '';
    } else {
      return cordova.file.dataDirectory + img;
    }
  }

removeImage()
{
  this.lastImage = null;
}

async uploadImage()
{

    var url         = " ";
    var targetPath  = this.pathForImage(this.lastImage);
    var filename    = this.lastImage;

    var options = {
      fileKey: "file",
      fileName: filename,
      chunkedMode: false,
      mimeType: "multipart/form-data",
      params : {'file': filename}
    };

    const fileTransfer: FileTransferObject = this.transfer.create();

    const loading = await this.loadingController.create({
        spinner:'bubbles',
      });

  await loading.present();

    // Use the FileTransfer to upload the image
    fileTransfer.upload(targetPath, url, options).then((data:any) => {

      this.presentToast(this.text.logo_success);

      window.location.href = "/account";

      loading.dismiss();

    }, err => {

      this.presentToast('Error while uploading file.');
      loading.dismiss();
    });
 }
}
